export class PhaseValueConstants {
    public static readonly Collaboration: number = 0;
    public static readonly QaReview : number = 1;
    public static readonly Formatting: number = 2;
    public static readonly InReview: number = 3;
    public static readonly ReadyForApproval: number = 4;
    public static readonly Approved: number = 5;
    public static readonly Effective: number = 6;
    public static readonly Archived: number = 7;
    public static readonly Cancelled: number = 8;
    public static readonly Obsolete : number = 9;
    public static readonly ClientSignature : number = 10;
}
